export const widgetDefault = {
  background: '#ffffff',
  text: '#000000',
  link: '#4B99E7',
}
